<style type="text/css" scoped>
.upload-csv-lable{
	height: 45;
	width:100%;
}

</style>

<template>
	<div>
		<v-row class="mb-5" >
			<v-col cols="8" md="8">
				<v-text-field
				v-model="warehouse_serch_query"
				:placeholder="$lang.WAREHOUSE_SEARCH"
				outlined
				rounded
				dense
				append-icon="mdi-magnify"
				@keyup="getWareHouseList"
				hide-details
				></v-text-field>
			</v-col>
			<v-col cols="4" md="4" class="text-right">
				<v-btn color="primary " @click="$router.push({name:'create-warehouse'})" >
					<b>{{$lang.ADD_WAREHOUSE}}</b>
				</v-btn>
			</v-col>

		</v-row>

		<v-data-table
		:headers="headers"
		:items="warehouse_list"
		:hide-default-footer="true"
		:disable-sort="true"
		:items-per-page="$keys.PAGE_LENGTH"
		class="elevation-1 custome-header-bg custome-table-body"
		:loading="table_loading"
		>
		<template v-slot:item.name="{ item }">
			<p>{{item.name}}</p>
			<p>{{item.email}}</p>
		</template>	
		<template v-slot:item.phone_number="{ item }">
			<p v-if="item.phone_number">{{$lang.MOBILE_PREFIX}}{{item.phone_number}}</p>
			<p v-if="item.alternate_phone_number">{{$lang.MOBILE_PREFIX}}{{item.alternate_phone_number}}</p>
		</template>	
		<template v-slot:item.city="{ item }">
			<p >{{item.city}}</p>
			<p >{{item.state}}</p>
		</template>	
		<template v-slot:item.action="{ item }">
			<v-btn small fab text @click="$router.push({name:'edit-warehouse',params:{warehouse_id:encript(item.id)}})">
				<img src="@/assets/edit.svg" alt="img">
			</v-btn>	
			<v-btn small fab text 
			@click="confirmationDeleteWarehouse(item)">	
			<img src="@/assets/delete.svg" alt="img">
		</v-btn>	
	</template>	
</v-data-table>

<!-- pginations -->
<v-pagination class="custome-pagination"  v-model="page_number" :total-visible="7" :length="total_page_count"
@input="warehouse_list"></v-pagination>

<confirm-delete-dialog :dialog="dialog" :deleteWarehouse="deleteWarehouse"/>

</div>
</template>

<script type="text/javascript">

export default{
	components:{
		ConfirmDeleteDialog:()=>import('./child/ConfirmDeleteDialog')
	},
	data(){
		return{
			upload_dialog:{
				flag:false
			},
			page_number:1,
			total_page_count:1,
			warehouse_serch_query:"",
			table_loading:false,
			warehouse_list:[],
			headers: [
			{ text: 'Name', align: 'start', sortable: false, value: 'name',},
			{ text: 'Phone Number', value: 'phone_number' },
			{ text: 'City', value: 'city' },
			// { text: 'State', value: 'state' },
			{ text: 'Address', value: 'address' },
			{ text: '', value: 'action' , width:120 },
			],

			dialog:{
				flag:false,
				warehouse_name:"",
				warehouse_id:"",
				dialog_loading:false,
			}
		}
	},
	created(){
		this.getWareHouseList(false)
	},
	methods:{
		getWareHouseList(is_cancel=true){
			const self=this
			let params={
				page_number:this.page_number,
				page_length:this.$keys.PAGE_LENGTH,
				search_query:this.warehouse_serch_query,
			};
			self.table_loading=true;
			const successHandler = (response) => {
				self.warehouse_list=response.data.warehouse_list
				self.total_page_count=response.data.total_page_count

			};
			const finallyHandler = () => {
				self.table_loading=false
			};
			self.request_GET( self,self.$urls.WAREHOUSE_LIST,params,successHandler,null,null,finallyHandler,is_cancel)
		},
		confirmationDeleteWarehouse(item){
			console.log(item)
			this.dialog.warehouse_id=item.id;
			this.dialog.warehouse_name=item.name;
			this.dialog.flag=true;
		},

		deleteWarehouse(){
			const self=this
			let params={
				Warehouse_id:this.dialog.warehouse_id
			};
			self.dialog_loading=true;
			const successHandler = (response) => {
				self.warehouse_list=response.data.warehouse_list
				self.total_page_count=response.data.total_page_count
			};
			const finallyHandler = () => {
				self.dialog_loading=false
			};
			self.request_GET( self,self.$urls.DELETE_WAREHOUSE,params,successHandler,null,null,finallyHandler)
		},
	}
}


</script>